import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory<any>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const confirmUserMfaReducer = createReducer<State, Actions>(initialState, {
  [actions.confirmUserMfa.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.confirmUserMfa.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.confirmUserMfa.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.confirmUserMfa.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default confirmUserMfaReducer;
